export default class Polynomial {
	constructor(coefficients) {
		if (!Array.isArray(coefficients))
			throw new Error('Coefficients must be an array')
		this._coeff = coefficients;
	}

	eval(x) {
		let result = 0;
		if (!this._coeff)
			return 0;
		for (let i = 0; i < this._coeff.length; i++) {
			const cf = this._coeff[i];
			if (i === 0) {
				result += cf;
				continue;
			}
			result += cf * Math.pow(x, i)
		}
		return result;
	}

	solve(y) {
		switch (this._coeff.length) {
			case 2:
				return this._solveLinear(this._coeff[1], this._coeff[0] - y)
			case 3:
				return this._solveQuadratic(this._coeff[2], this._coeff[1], this._coeff[0] - y)
			default:
				throw new Error('Not implemented')
		}
	}

	toString(variable = 'x', format = d3.format('.2f')) {
		let result = '';
		if (this._coeff.length === 0)
			return format(0)
		if (this._coeff.length === 1)
			return format(this._coeff[0]);
		for (let i = this._coeff.length - 1; i >= 0; i--) {
			let val = this._coeff[i];
			if (val === 0) // skip zeroes
				continue;
			if (i !== this._coeff.length - 1 && result.length > 0) // add sign
				result += (val > 0 ? ' + ' : ' - ');
			if (val !== 1 || i === 0){
				if (result.length > 0)
					val = Math.abs(val)
				result += format(val);
			}
			if (i !== 0) // add variable (e.g. 'x'), except intercept coefficient
				result += variable;
			if (i > 1) // add power, except last two coefficients
				result += `^${i}`
		}
		return result.length > 0 ? result : format(0);
	}

	_solveLinear(a, b) {
		return -b / a;
	}

	_solveQuadratic(a, b, c) {
		const d = Math.pow(b, 2) - (4 * a * c);
		return (-b + Math.sqrt(d)) / (2 * a);
	}
}